/** Códigos API para Tipo de Cliente. Valor persistido → etiqueta UI. */
export const TIPO_CLIENTE_OPTIONS: { value: string; label: string }[] = [
  { value: 'A', label: 'Activo' },
  { value: 'E', label: 'Eventual' },
  { value: 'I', label: 'Inactivo' },
  { value: 'S', label: 'Suspendido' },
];

export function labelTipoCliente(codigo: string | null | undefined): string {
  if (codigo == null || codigo === '') return '—';
  const found = TIPO_CLIENTE_OPTIONS.find((o) => o.value === codigo.trim().toUpperCase());
  return found?.label ?? codigo;
}
